'use client';

import { usePathname } from 'next/navigation';
import { cn } from '@fshr/shared-react';

import { Link, LinkIfFullyAuthenticated } from '@fshr/components';
import type { NavigationLink } from '@micro-apps/env';

export type MobileNavigationLink = NavigationLink & {
	requiresFullAuthentication?: boolean;
	showActive?: (pathname: string) => boolean;
};

export default function MobileNavLinks({
	links = [],
	className,
	isFullyAuthenticated,
	close,
}: {
	links: MobileNavigationLink[];
	className?: string;
	isFullyAuthenticated: boolean;
	close?: () => void;
}) {
	const pathname = usePathname();
	return (
		<div className={className}>
			<div className="min-h-0">
				<ul className="flex flex-col flex-nowrap gap-200 mb-[35px]">
					{links.map(({ text, link, requiresFullAuthentication = false, showActive }) => {
						const isActive = (showActive || ((pathname: string) => link === pathname))(pathname);
						const className = cn(
							[
								'uppercase',
								'font-sans',
								'font-normal',
								'text-[12px]',
								'tracking-[2px]',
								'text-black',
								'hover:text-neutral-900',
								'focus:text-neutral-900',
								'transition-colors',
							],
							{
								'font-bold': isActive,
								"font-[700] before:content-[''] before:border-[8px] before:border-transparent before:border-l-black before:absolute before:top-1/2 before:left-0 before:-mt-[8px]":
									isActive,
							}
						);
						const linkProps = {
							href: link,
							className,
							prefetch: false,
							children: text,
							onClick: close,
						};
						return (
							<li key={text} className="px-[35px] relative">
								{requiresFullAuthentication ? (
									<LinkIfFullyAuthenticated
										intent="unstyled"
										isFullyAuthenticated={isFullyAuthenticated}
										{...linkProps}
									/>
								) : (
									<Link intent="unstyled" {...linkProps} />
								)}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
}
